import React from 'react';

// Components
import { ResponsiveImage } from '@shopee-user/shared-customization-ui';
import { ResponsiveImageUseCase } from '@shopee-user/business-customization-types';

// Assets
import logoMdpi from './assets/logo-1x.png';
import logoHdpi from './assets/logo-1.5x.png';
import logoXhdpi from './assets/logo-2x.png';
import logoXxhdpi from './assets/logo-3x.png';
import logoXxxhdpi from './assets/logo-4x.png';

import { SrcSet } from '@shopee-user/business-customization-types';

export default function OneCredentialDelinkLogo({
  className,
}: {
  className?: string;
}) {
  function getSrcSet(): SrcSet[] {
    return [
      { src: logoMdpi, size: '1x' },
      { src: logoHdpi, size: '1.5x' },
      { src: logoXhdpi, size: '2x' },
      { src: logoXxhdpi, size: '3x' },
      { src: logoXxxhdpi, size: '4x' },
    ];
  }

  return (
    <ResponsiveImage
      usecase={ResponsiveImageUseCase.DelinkLogo}
      className={className}
      defaultSrc={logoXhdpi}
      srcSet={getSrcSet()}
    />
  );
}
